import { ILocalStorage } from '@utils';

const IGETUSER = 'IGetCool-USER-Info';
const notClearList = ['mallCourseProptShowTime'];

export function getUser() {
  return ILocalStorage(IGETUSER) || null;
}

export function setUser(user) {
  return ILocalStorage(IGETUSER, user);
}

export function removeUserinfo() {
  return localStorage.removeItem(IGETUSER);
}

export function removeUser() {
  const whitelist = {};
  // 先取出来
  notClearList.forEach(item => {
    const r = ILocalStorage(item);
    r && (whitelist[item] = r);
  });
  const result = localStorage.clear(IGETUSER);
  // 再存进去
  notClearList.forEach(item => {
    const r = whitelist[item];
    r && (ILocalStorage(item, r));
  });
  return result;
}